<!-- /src/components/common/Header/Header.vue -->
<template>
    <div id="header">
      <header class="header">
        <div class="header--color"></div>
        <div class="header__container">
          <div class="header__branding">
            <div class="header__apps">
                <!-- Changed from apps menu trigger to home link by client request — July 2026 -->
                <router-link
                  class="header__apps__items__item menu--trigger"
                  to="/"
                >
                  <i class="fas fa-th icon"></i>
                </router-link>
            </div>
            <div class="header__logo">
              <a href="https://ai.carr.us">
                <Logo />
              </a>
            </div>
          </div>
          <div class="header__search">
            <div class="header__search__field">
              <input
                type="text"
                class="header__search__input"
                :class="colorClassBlue"
                placeholder="Search..."
                ref="search"
                :value="searchInput"
                @input="updateSearch"
              />
              <button
                class="header__search__input__button"
              >
                <i class="fal fa-search icon"></i>
              </button>
            </div>
            <div class="header__search__helper">Search Agent Central for templates, comparisons, tools, and resources. Have a real estate question? Ask CARR AI.</div>
          </div>
          <div class="button__group header__button__group">
            <!-- <BackButton :classes="'button--sm'" /> -->
            <div class="header__nav"
              v-click-outside="disableMenu"
              :class="{'is-active': ($store.getters.headerMenuVisible)}"
            >
              <button
                class="header__nav__items__item menu--trigger"
                :class="{'is-active': $store.getters.headerMenuVisible}"
                @click="toggleMenu()"
              >
                <transition name="trigger">
                  <i v-show="!($store.getters.headerMenuVisible)"
                    class="fas fa-bars icon"></i>
                </transition>
                <transition name="trigger">
                    <i
                      v-show="$store.getters.headerMenuVisible"
                    class="fa fa-times-square icon"></i>
                </transition>
              </button>
            <transition name="headerMenu">
              <HeaderMenu
                v-if="$store.getters.headerMenuVisible"
                @navigate="toggleMenu()"
              />
            </transition>
            </div>
          </div>
        </div>
      </header>
      <!-- AppsMenu overlay removed by client request — July 2026.
           External links moved into HeaderMenu dropdown.
           AppsMenu.vue preserved for potential reversion. -->
      <!-- <transition name="appMenu">
        <AppsMenu
          v-if="$store.getters.appsMenuVisible"
          @navigate="appsMenu()"
        />
      </transition> -->    </div>
</template>

<script>
import Logo from './_HeaderLogo'
import HeaderMenu from './HeaderMenu'
// import AppsMenu from './AppsMenu' // Removed by client request — July 2026
import BackButton from '@/components/common/BackButton'
import defaults from 'lodash/defaults'
import _isUndefined from 'lodash/isUndefined'
import resizeMixin from '@/mixins/resizeMixin'


export default {
  data() {
    return {
      // searchInput: '',
      searchVisible: false,
      tabletOrGreater: false,
      timeout: null,
    }
  },

  computed: {
    avatar() {
      return this.$store.getters['user/getUser'].avatar_urls
        ? this.$store.getters['user/getUser'].avatar_urls[48]
        : false
    },
		colorClassBlue() {
			return this.$store.getters['getHeaderRevState'] ? 'color-white' : 'color-blue'
		},

    searchInput() {
      return this.$store.getters['getSearchInputValue']
    },
  },

  methods: {
    toggleMenu() {
      this.$store.dispatch('toggleHeaderMenu')
    },

    // appsMenu() {
    //   this.$store.dispatch('toggleAppsMenu')
    // }, // Removed by client request — July 2026

    updateSearch(e) {
      const { runSearch } = this
      
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.$store.dispatch('updateSearchInputValue', e.target.value)
        runSearch()
      }, 500)
    },

    // toggleSearch() {
    //   this.searchVisible = !this.searchVisible
    //   this.$refs.search.focus()
    // },

    // getSearchInputQuery() {
    //   const { $route } = this
    //   const { query } = $route
    //   return !_isUndefined(query['search']) ? query['search'] : ''
    // },

    disableMenu() {
      // console.log(this.$refs['header-menu'])
      this.$store.dispatch('toggleHeaderMenu')
      this.clearSearch()
    },
    
    clearSearch() {
      this.searchInput = ''
      this.runSearch()
    },

    runSearch() {
      // set up deburr for this 
      const queryModifier = {}
      let { ...query } = this.$route.query
      queryModifier['page'] = 1
      if (this.searchInput !== '') {
        queryModifier['search'] = this.searchInput
      } else {
        delete query['search']
      }
      query = Object.assign(defaults(queryModifier, query))

      this.$router.push({
        name: 'search',
        query,
      }).catch(err => {
        // Ignore the vuex err regarding  navigating to the page they are already on.
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          console.log(err);
        }
      })
    },

    onResize() {
      this.tabletOrGreater = window.innerWidth > 760 ? true : false
    },
  },

  components: {
    Logo,
    HeaderMenu,
    // AppsMenu, // Removed by client request — July 2026
    BackButton,
  },

  mixin: [resizeMixin],

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },

  beforeMount() {
    // this.$store.dispatch('updateSearchInputValue', this.getSearchInputQuery())
    // this.searchVisible = this.$route.name === 'search' ? true : false
    // this.onResize()
  },
}
</script>

<style scoped>

#header {
  z-index: 10;
}

.header {
  /* background-color: var(--brandPrimary); */
  position: relative;
  /* display: flex; */
  padding: var(--itemSpacing) 0 0 0;
  /* align-items: center; */
  /* width: 100%; */
  z-index: 9;

  /* &:before {
    left: 0;
    top: 0;
    right: 0;
    height: 100%;
    content: '';
    pointer-events: none;
    position: absolute;
    z-index: -100;
    background-image: linear-gradient(to top, rgba(var(--brandPrimary-RGB),0), rgba(var(--brandPrimary-RGB),1));

  } */



  &__container {
    /* width: calc(100% - (var(--itemSpacing) * 2)); */
    width: 100vw;
    max-width: var(--desktop-width);
    display: grid;
    /* grid-template-columns: 1fr auto; */
    grid-gap: 2rem;
    grid-row-gap: 1rem;
    margin: 0 auto;
    position: relative;
    /* display: flex; */
    justify-content: space-between;
    /* align-items: center; */
    padding: 0 5%;

    /* @media (--tablet) { */
      grid-template-columns: 1fr auto;
    /* } */

    @media (--tablet-landscape) {
      grid-template-columns: 18rem 1fr auto;
      grid-gap: 1rem;
    }

    @media(--tablet) {
      padding: 0 var(--itemSpacing-lg);
    }

  }

  &__logo {
    width: 100%;
    max-width: 205px;
  }

  &__search {
    position: relative;
    /* grid-column: 1 / span 2; */

    /* @media (--tablet) { */
      grid-row: 2;
      grid-column: 1 / span 2;
    /* } */

    @media (--tablet-landscape) {
      grid-row: 1;
      grid-column: 2;
    }

    /* Comp 1.0-F: helper line under the search bar. */
    /* Wrapper keeps the spyglass centered on the input itself now
       that the helper line makes the container taller. */
    &__field {
      position: relative;
    }

    &__helper {
      margin-top: 0.35rem;
      color: rgba(255, 255, 255, 0.85);
      font-size: 0.7rem; /* 14px at 20px root */
      text-align: center;
    }

    &__input {
      background-color: rgba(255, 255, 255, 0.125);
      border: 1px solid rgba(255, 255, 255, 0.25);
      border-radius: 4px;
      padding: 0.5rem 2rem 0.5rem 0.75rem;
      color: var(--brandPrimary);
      font-weight: 600;
      opacity: 1;
      transition: opacity 0.2s ease;
      will-change: opacity;
      /* box-shadow: inset 0 0 1rem rgba(0, 0, 0, 0.25); */

      &.color-white {
        color: #fff;
      }

      &.color-blue {
        color: var(--brandPrimary);
      }

      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: white;
      }

      &::-moz-placeholder {
        /* Firefox 19+ */
        color: white;
      }

      &:-ms-input-placeholder {
        /* IE 10+ */
        color: white;
      }

      &:-moz-placeholder {
        /* Firefox 18- */
        color: white;
      }
    }

    button {
      position: absolute;
      right: .25rem;
      top: 50%;
      transform: translateY(-50%);
      color: white;
      background: transparent;
      border: none;
      outline: none;
    }

    &--active {
      /* .header__search__input { */
      opacity: 1;
      /* } */
    }
  }

  &__branding {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-gap: 2rem;
    /* ACR (2026-09-25): top-align instead of centering so the header
       rows read aligned with the search field block. */
    align-items: start;
    grid-column: span 1;

    @media(--tablet) {
      grid-column: span 1;
    }
  }

  &__nav,
  &__apps {
    /* ACR (2026-09-25): 5px optical offset matching .header__button__group. */
    margin-top: 5px;

    &__items {
      &__item {
        color: white;
        cursor: pointer;
      }
    }
  }

  &__nav {
    position: relative;

    &.is-active {
      .menu--trigger {
        color: var(--brandAccent);
      }
    }

  }

  &__button {
    &__group {
      /* display: grid; */
      /* grid-template-columns: 1fr; */
      justify-self: end;
      /* ACR (2026-09-25): top-align + 5px optical offset (matches
         .header__apps) now that branding is top-aligned. */
      align-self: start;
      margin-top: 5px;
      @media(--tablet) {
        display: flex;
      }
    }
  }

  .menu--trigger {
    display: inline-block;
    width: 1.5rem;
    position: relative;
    height: 1.75rem;

    i {
      position: absolute;
      left: 0;
      top: 0;
    }

    .icon {
      font-size: 1.5rem;
    }
  }
}

.headerMenu-enter-active,
.headerMenu-leave-active {
  transition: opacity var(--animationDurationMedium) ease 0.2s,
    transform var(--animationDurationMedium) ease 0.2s;
  will-change: opacity, transform;
}

.headerMenu-enter,
.headerMenu-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.appMenu-enter-active,
.appMenu-leave-active {
  transition: opacity var(--animationDurationMedium) ease 0.2s,
    transform var(--animationDurationMedium) ease 0.2s;
  will-change: opacity, transform;
}

.appMenu-enter,
.appMenu-leave-to {
  opacity: 0;
  transform: translateY(-100%);
}

.trigger-enter-active,
.trigger-leave-active {
  transition: opacity ease 0.2s,
    transform ease 0.5s;
  will-change: opacity, transform;
}

.trigger-enter,
.trigger-leave-to {
  opacity: 0;
  transform: rotate(-180deg);
}
</style>
